<template>
  <v-lottie-player
    width="100%"
    height="100%"
    name="confetti"
    :loop="loop"
    path="https://assets6.lottiefiles.com/private_files/lf30_vsiskxym.json"
  />
</template>

<script lang="ts">
import VueLottiePlayer from '../vue_lottie_player/VueLottiePlayer.vue';

export default {
  name: 'Confetti',
  components: {
    vLottiePlayer: VueLottiePlayer,
  },
  props: {
    loop: {
      default: false,
      type: Boolean,
    },
  },
};
</script>
